// @flow
import JQueryView from '../../common/JQueryView';

declare var $: any;

export default class ShowView extends JQueryView {
  constructor() {
    super('#sb-site');

    this.setScrollFloatingFooter();
  }

  setScrollFloatingFooter() {
    $(window).on('scroll', () => {
      $('.js-floating').addClass('is-visible');
    });
  }
}
